

export function selectImage(image) {
    return {
        type: 'SELECT_IMAGE',
        image
    }
}

export function clearImageSelection() {
    return {
        type: 'CLEAR_IMAGE_SELECTION'
    }
}



// WEBPACK FOOTER //
// ./src/actions/galleryActions.js